import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=6e71bd22&scoped=true&"
import script from "./Achievement.vue?vue&type=script&lang=js&"
export * from "./Achievement.vue?vue&type=script&lang=js&"
import style0 from "./Achievement.vue?vue&type=style&index=0&id=6e71bd22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71bd22",
  null
  
)

export default component.exports